const KeyBenefits = ({ benefits, variant = 'default', className = '' }) => {
  // Default benefits if none provided
  const defaultBenefits = [
    {
      title: 'Real Interview Experience',
      description: 'Face questions from actual senior engineers'
    },
    {
      title: 'Actionable Feedback',
      description: 'Get detailed reports on what to improve'
    },
    {
      title: 'Flexible Scheduling',
      description: 'Book sessions that fit your timeline'
    }
  ];

  const displayBenefits = benefits || defaultBenefits;
  const defaultIcon = '✓';

  // Variant styles
  const variants = {
    default: {
      container: 'grid md:grid-cols-3 gap-6',
      checkmark: 'flex-shrink-0 w-8 h-8 bg-orange-400 rounded-full flex items-center justify-center text-orange-900 font-bold text-lg mt-1 animate-bounce',
      title: 'font-semibold text-lg mb-1 text-white',
      description: 'text-green-100 text-sm'
    },
    compact: {
      container: 'flex flex-wrap justify-center gap-3 sm:gap-4',
      checkmark: 'text-xl sm:text-2xl animate-bounce',
      title: 'font-semibold text-sm sm:text-lg text-white',
      description: 'hidden'
    },
    horizontal: {
      container: 'flex flex-wrap justify-center gap-6',
      checkmark: 'flex-shrink-0 w-6 h-6 bg-orange-400 rounded-full flex items-center justify-center text-orange-900 font-bold text-sm animate-bounce',
      title: 'font-semibold text-base text-white',
      description: 'text-green-100 text-xs'
    }
  };

  const styles = variants[variant] || variants.default;

  if (variant === 'compact') {
    return (
      <div className={`${styles.container} ${className}`}>
        {displayBenefits.map((benefit, index) => (
          <div key={index} className="flex items-center gap-2">
            <span className={styles.checkmark}>{benefit.icon || defaultIcon}</span>
            <span className={styles.title}>{benefit.title}</span>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={`${styles.container} ${className}`}>
      {displayBenefits.map((benefit, index) => (
        <div key={index} className="flex items-start gap-3">
          <div className={styles.checkmark}>
            {benefit.icon || defaultIcon}
          </div>
          <div>
            <h3 className={styles.title}>{benefit.title}</h3>
            <p className={styles.description}>{benefit.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default KeyBenefits;
